
import { 
    GET_HOSPITAL_DROPDOWN,
    GET_HOSPITAL_DROPDOWN_SUCCESS,
    GET_HOSPITAL_DROPDOWN_FAIL, 
    GET_HOSPITAL_DROPDOWN_RESET,
} from "../actions/getHospitalDropdownAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getHospitalDropdownReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HOSPITAL_DROPDOWN:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_HOSPITAL_DROPDOWN_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_HOSPITAL_DROPDOWN_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_HOSPITAL_DROPDOWN_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getHospitalDropdownReducer;
